import { Command } from 'commander';
import type { BrandConfig } from './branding/types';
import { buildInitCommand } from './cli/init';
import { buildRunCommand } from './cli/run';
import { buildValidateCommand } from './cli/validate';
import { buildAuditCommand } from './cli/audit';
import { buildCapsCommand } from './cli/caps';
import { buildListCommand } from './cli/list';
import { buildRevokeCommand } from './cli/revoke';

/**
 * Build a Commander program for one whitelabel. The whitelabel's `bin.ts`
 * calls `createCli(brand).parseAsync(process.argv)`.
 *
 * Every subcommand reads `brand` from the closure; nothing in the
 * substrate looks at a global.
 */
export function createCli(brand: BrandConfig): Command {
  const program = new Command();

  program
    .name(brand.product.cliBinary)
    .description(brand.product.description)
    .version(brand.product.version);

  program.addCommand(buildInitCommand(brand));
  program.addCommand(buildRunCommand(brand));
  program.addCommand(buildValidateCommand(brand));
  program.addCommand(buildAuditCommand(brand));
  program.addCommand(buildCapsCommand(brand));
  program.addCommand(buildListCommand(brand));
  program.addCommand(buildRevokeCommand(brand));

  return program;
}
